export default __webpack_public_path__ + "static/media/icn-log.7a8b3467.svg";